module.exports = __webpack_public_path__ + "img/flag-icon-sgp.c7cbf129.svg";